import { render, staticRenderFns } from "./UpdateCourseInstructorDialog.vue?vue&type=template&id=152a286f&scoped=true"
import script from "./UpdateCourseInstructorDialog.vue?vue&type=script&lang=js"
export * from "./UpdateCourseInstructorDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateCourseInstructorDialog.vue?vue&type=style&index=0&id=152a286f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152a286f",
  null
  
)

export default component.exports